import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EncodingService {
  // as per RFC7636
  public convertBase64toBase64Url(base64Str: string): string {
    return base64Str.split('=')[0]
      .replace(/\+/g, '-')
      .replace(/\//g, '_');
  }
}
